import { GetServerSidePropsContext, NextPageContext } from "next";

import serverConfig from "config/server";
import { isLocalDev } from "utils/isLocalDev";

export const getRequestHeader = (
  ctx: NextPageContext | GetServerSidePropsContext,
  key: string,
  localValue: string
) => {
  const { req } = ctx;
  const header = req && req.headers && req.headers[key];

  if (header) {
    return header;
  }

  if (isLocalDev()) {
    return localValue;
  }
};

export const getCountryCodeHeader = (
  ctx: NextPageContext | GetServerSidePropsContext
) => {
  if (isLocalDev()) {
    return serverConfig.developmentDomainCountryCode;
  }

  const countryCodeHeader =
    getRequestHeader(ctx, "x-country-code", "US") || "US";

  return Array.isArray(countryCodeHeader)
    ? countryCodeHeader[0]
    : countryCodeHeader;
};
